export const queryNameToFacetNameMap: {
    queryName: string
    facetName: string
}[] = [
    { queryName: 'fn', facetName: 'firmName' },
    { queryName: 'df', facetName: 'displayNameWithFirmName' },
    { queryName: 'pt', facetName: 'productType' },
    { queryName: 'ct', facetName: 'categories' },
    { queryName: 'll', facetName: 'listingLevels' },
    { queryName: 'ss', facetName: 'submissionStatus' },
    { queryName: 'ia', facetName: 'isActive' },
    { queryName: 'pr', facetName: 'partnerships' },
    { queryName: 'sn', facetName: 'sectionNames' },
    { queryName: 'sp', facetName: 'sectionNameWithProductType' },
    { queryName: 'ac', facetName: 'additionalContent' },
    { queryName: 'adu', facetName: 'assignedDeltekUsers' },
    { queryName: 'ptp', facetName: 'productTypeProperties' },
    { queryName: 'mo', facetName: 'withManufacturerOption' },
    { queryName: 'nr', facetName: 'noteReasons' },
]
export const queryNameToDateParamMap: {
    queryName: string
    facetName: string
}[] = [
    { queryName: 'usd', facetName: 'lastUpdatedStartDate' },
    { queryName: 'ued', facetName: 'lastUpdatedEndDate' },
    { queryName: 'uxd', facetName: 'lastUpdatedInPastDays' },
]
